module.exports = __webpack_public_path__ + "static/media/pizza.01f004a4.svg";